import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddDistrict = (props) => {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState(
    props.mode === "edit" ? props.districtEdit.name : ""
  );
  const [districtsArr, setDistrictsArr] = useState(
    props.mode === "edit" ? JSON.parse(props.districtEdit.companies) : []
  );
  const [edit, setEdit] = useState(props.mode === "edit" ? false : true);
  const [actualSource, setActualSource] = useState(props.companies[0].name);
  const [actualPercent, setActualPercent] = useState(0);

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const validate = () => {
    if (!name && districtsArr.length === 0) {
      return false;
    } else {
      return true;
    }
  };

  const fetchAddDistrict = async () => {
    var body = {
      name: name,
      companies: JSON.stringify(districtsArr),
    };

    await fetch("https://apisplit.ftpeople.pl/addDistrict", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Oddział",
          text: "dodany",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const addDistrict = () => {
    if (validate()) {
      fetchAddDistrict();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const generateDistrict = () => {
    if (districtsArr.length === 0) {
      return "";
    } else {
      var ret = "";
      districtsArr.map((brand, index) => {
        ret = ret + (index === 0 ? "" : ",") + brand;
      });
      return ret;
    }
  };

  const fetchEditDisctrict = async () => {
    var body = {
      id: props.districtEdit.id,
      name: name,
      companies: JSON.stringify(districtsArr),
    };

    await fetch("https://apisplit.ftpeople.pl/editDistrict", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Oddział",
          text: "zmieniony",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const editDistrict = () => {
    if (validate()) {
      fetchEditDisctrict();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const fetchDeleteDistrict = async (newUser) => {
    var body = { id: props.districtEdit.id };

    await fetch("https://apisplit.ftpeople.pl/deleteDistrict", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Oddział",
          text: "usunięty",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const deleteDistrict = (e) => {
    fetchDeleteDistrict();
  };

  const endEditMode = (e) => {
    setEdit(false);
    setName(props.districtEdit.name);

    setDistrictsArr(props.districtEdit.brands.split(","));
  };

  const handleDistrictAdd = (e) => {
    setLoading(true);
    var obj = {
      name: actualSource,
      per: actualPercent,
    };
    var arr = [];
    arr =
      districtsArr.length > 0
        ? districtsArr.filter((brand) => brand.name !== actualSource)
        : [];
    arr.push(obj);
    setDistrictsArr(arr);
    setLoading(false);
  };

  return (
    <>
      <div
        style={{
          width: "30vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "2",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                {edit
                  ? props.mode === "edit"
                    ? "EDYTUJ ODDZIAŁ"
                    : "DODAJ ODDZIAŁ"
                  : "ODDZIAŁ"}
                <br />
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px" }}>
              <div style={{ width: "85%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  nazwa <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
            </div>

            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "85%", textAlign: "left" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ width: "50%" }}>
                    <p
                      style={{
                        margin: "0",
                        marginBottom: "10px",
                        fontWeight: "600",
                        fontSize: ".8vw",
                        paddingLeft: "20px",
                      }}
                    >
                      źródła <span style={{ color: "red" }}>*</span>
                    </p>
                    <select
                      style={{
                        width: "100%",
                        padding: "0px 10px",
                        boxSizing: "border-box",
                      }}
                      disabled={!edit}
                      value={actualSource}
                      onChange={(e) => {
                        setActualSource(e.target.value);
                      }}
                    >
                      {props.companies.map((el) => (
                        <option value={el.name}>{el.name}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ width: "50%" }}>
                    {" "}
                    <p
                      style={{
                        margin: "0",
                        marginBottom: "10px",
                        fontWeight: "600",
                        fontSize: ".8vw",
                        paddingLeft: "20px",
                      }}
                    >
                      udział leadów (%) <span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      style={{
                        width: "100%",
                        padding: "0px 10px",
                        boxSizing: "border-box",
                      }}
                      type="number"
                      disabled={!edit}
                      value={actualPercent}
                      onChange={(e) => {
                        if (e.target.value <= 100) {
                          setActualPercent(e.target.value);
                        }
                      }}
                    />
                  </div>
                </div>
                <button
                  className="loginButtonLogin"
                  id={"statusNote"}
                  value={0}
                  style={{
                    margin: "0",
                    backgroundColor: !edit ? "gray" : "navy",
                    borderColor: !edit ? "gray" : "navy",
                    width: "45%",
                    fontSize: ".6vw",
                    padding: "5px 5px",
                    marginTop: "10px",
                  }}
                  onClick={() => {
                    handleDistrictAdd();
                  }}
                  disabled={!edit}
                >
                  dodaj
                </button>
                <div style={{ marginTop: "20px", width: "100%" }}>
                  {districtsArr.map((brand) => (
                    <>
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "50%" }}>{brand.name}</div>
                        <div style={{ width: "20%" }}>{brand.per}%</div>
                        <div style={{ width: "30%" }}>
                          <button
                            className="loginButtonLogin"
                            id={"statusNote"}
                            value={brand.name}
                            disabled={!edit}
                            style={{
                              margin: "0",
                              backgroundColor: !edit ? "gray" : "navy",
                              borderColor: !edit ? "gray" : "navy",
                              width: "45%",
                              fontSize: ".6vw",
                              padding: "5px 5px",
                            }}
                            onClick={(e) => {
                              console.log(e.target.value);
                              setDistrictsArr(
                                districtsArr.filter(
                                  (brandX) => brandX.name !== e.target.value
                                )
                              );
                            }}
                          >
                            usuń
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: "50px",
                display: "flex",
                gap: "20px",
              }}
            >
              {edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                    onClick={props.mode === "edit" ? editDistrict : addDistrict}
                  >
                    {props.mode === "edit" ? "EDYTUJ" : "DODAJ"} ODDZIAŁ
                  </button>
                </>
              ) : (
                ""
              )}
              {props.mode === "edit" && !edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "navy",
                      borderColor: "navy",
                    }}
                    onClick={() => setEdit(true)}
                  >
                    TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" && edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={endEditMode}
                  >
                    ZAKOŃCZ TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={deleteDistrict}
                  >
                    USUŃ
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddDistrict;
